import { all } from "redux-saga/effects";

import { watchIntegrationsSms } from "./sms/sms.sagas";

export function *watchProducts () {
    yield all([
        watchIntegrationsSms
    ]);
}